module.exports = __webpack_public_path__ + "static/media/plus-icon.d77f0aed.svg";